"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilesPreviewViewPure = exports.lifecycles = exports.Footer = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var moment = require("moment");
var connected_react_router_1 = require("connected-react-router");
var Types = require("types");
var TypesLib = require("@caddigital/sok-types");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var revisionsActions = require("@caddigital/sok-reducers/lib/actions/revisions");
var sort_1 = require("utils/sort");
var fullscreen_1 = require("../../utils/fullscreen");
var translate_1 = require("utils/translate");
var formatSize_1 = require("utils/helpers/formatSize");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var Header_1 = require("./Header");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var Icon_1 = require("components/Icon");
var fileListFilter_1 = require("utils/helpers/fileListFilter");
var components_1 = require("./components");
require("./style.scss");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)() || 'en';
    return {
        user: state.auth.current.user,
        preview: state.files.preview,
        files: state.files.data.files,
        filteredMetadataColumns: state.files.fileList.filteredMetadataColumns,
        sortByOptions: state.files.sortByOptions,
        searchOptions: state.files.searchOptions,
        token: state.auth.current.token,
        filtering: state.files.searchOptions.filtering,
        folderPath: state.files.folderPath,
        selectedLanguage: selectedLanguage,
        metadata: state.files.metadata
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    moveTo: function (url) { return dispatch((0, connected_react_router_1.push)(url)); },
    fetchRevisions: function (fileUUID) {
        return dispatch(revisionsActions.fetchRequest(fileUUID, 'COMPLETE'));
    },
    setPreviewRevision: function (revision) {
        return dispatch(FilesActions.setPreviewRevision(revision));
    },
    fetchFiles: function (folderId, sortByOptions, searchOptions) {
        dispatch(FilesActions.fetchFiles(folderId, sortByOptions, searchOptions));
    },
    convert: function (revision) {
        dispatch(FilesActions.generatePreviewRequest(revision.uuid));
    },
    navigateTo: function (url, filtering) {
        if (!filtering) {
            dispatch(FilesActions.resetSearchOptionsAction());
            dispatch(FilesActions.resetSortOptionsAction());
        }
        dispatch((0, connected_react_router_1.push)(url));
    },
    moveToRevision: function (path, fileUUID, revisionUuid) {
        var splitted = path.split('/');
        if (path.includes('revision')) {
            dispatch((0, connected_react_router_1.push)(splitted.slice(0, splitted.length - 3).join('/') +
                "/".concat(fileUUID, "/revision/").concat(revisionUuid)));
        }
        else {
            dispatch((0, connected_react_router_1.push)(path.replace(/\/+$/, '') + "/revision/".concat(revisionUuid)));
        }
    },
    changeExpand: function (expand, folder) {
        return dispatch(FilesActions.PreviewActions.treeActions.copyChangeExpand(expand, folder));
    },
    selectItem: function (folder, value) {
        dispatch(FilesActions.PreviewActions.treeActions.selectFile(folder, value));
    },
    getContent: function (parent) {
        return dispatch(FilesActions.PreviewActions.treeActions.fetchTree(parent, ['FOLDER', 'IFC'], 'MINIMAL'));
    },
    clearTree: function () { return dispatch(FilesActions.PreviewActions.treeActions.clear()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var StatePropsWitness = Types.extractReturnType(exports.mapStateToProps);
var DispatchPropsWitness = Types.extractReturnType(exports.mapDispatchToProps);
var metadataFormat = function (cm, projectMeta, item) {
    if (projectMeta.type === 'day') {
        return cm.value && cm.value !== ''
            ? moment(parseInt(cm.value.toString(), 10)).format('l')
            : '-';
    }
    else if (projectMeta.type === 'datetime') {
        return cm.value && cm.value !== ''
            ? moment(parseInt(cm.value.toString(), 10)).format('l HH:mm')
            : '-';
    }
    else if (cm.uuid === 'size-meta') {
        return cm.value ? (0, formatSize_1.formatSize)(parseInt(cm.value.toString(), 10)) : '-';
    }
    else if (projectMeta.type === 'checkbox') {
        // TypesLib.CustomMeta.Metadata
        return cm.value ? projectMeta.name : '-';
    }
    else {
        return cm.value && cm.value !== '' ? cm.value : '-';
    }
};
var getAuthor = function (revision) {
    var authorMeta = revision.customMeta &&
        revision.customMeta.find(function (x) { return x.uuid === 'added-by-meta'; });
    if (authorMeta) {
        return authorMeta.value;
    }
    return '-';
};
var getCreatedAt = function (revision) {
    var createdMeta = revision.customMeta &&
        revision.customMeta.find(function (x) { return x.uuid === 'added-meta'; });
    if (createdMeta) {
        return createdMeta.value
            ? moment(parseInt(createdMeta.value.toString(), 10)).format('L LT')
            : '-';
    }
    return '-';
};
var Footer = function (props) { return (React.createElement("div", { className: 'viewer-footer' },
    React.createElement("div", { className: 'row' }, props.metaSchema
        .sort(function (a, b) { return a.order - b.order; })
        .reduce(function (acc, x) {
        if ((x.bitField & TypesLib.CustomMeta.FILES_LIST) === 0) {
            return acc;
        }
        var idx = props.revision.customMeta.findIndex(function (cm) { return cm.uuid === x.identifier; });
        acc.push(React.createElement("div", { className: 'column medium-4 extra-small-12' },
            React.createElement("div", { className: 'details-block' },
                React.createElement("div", { className: 'title' }, x.name),
                React.createElement("div", { className: 'content' }, x.identifier === 'name-meta'
                    ? props.revision.name
                    : props.revision.customMeta &&
                        props.revision.customMeta[idx]
                        ? metadataFormat(props.revision.customMeta[idx], x, props.revision)
                        : '-'))));
        return acc;
    }, [])))); };
exports.Footer = Footer;
var RevisionList = (0, recompose_1.pure)(function (props) { return (React.createElement("div", { className: 'revision-list' }, props.children)); });
var Content = (0, recompose_1.pure)(function (props) { return (React.createElement("div", { className: 'viewer-task-container overlay' }, props.children)); });
exports.lifecycles = (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.fetchRevisions(this.props.match.params.fileUUID);
    },
    componentWillReceiveProps: function (nextProps) {
        if (this.props.match.params.fileUUID !== nextProps.match.params.fileUUID) {
            nextProps.fetchRevisions(nextProps.match.params.fileUUID);
            nextProps.setSelectedRevisions([]);
        }
        if (this.props.match.params.revisionUuid !==
            nextProps.match.params.revisionUuid ||
            (this.props.preview.status !== nextProps.preview.status &&
                nextProps.preview.status === 'FETCHED')) {
            this.props.setSelectedRevisions([]);
            this.props.clearTree();
            var revisionUuid_1 = nextProps.match.params.revisionUuid
                ? nextProps.match.params.revisionUuid.trim()
                : null;
            var revision = nextProps.match.params.revisionUuid
                ? nextProps.preview.revisions.find(function (f) { return f.uuid === revisionUuid_1; })
                : nextProps.preview.revisions[0]; // Use latest revision by default
            if (revision) {
                nextProps.setPreviewRevision(revision);
            }
        }
        if (this.props.files !== nextProps.files) {
            // visible columns
            var columns = (0, fileListFilter_1.filterMetadataColumns)(nextProps.metadata.status === 'FETCHED' ? nextProps.metadata.list : [], nextProps.filteredMetadataColumns).sort(function (a, b) { return a.order - b.order; });
            // Set only the visible columns ans filters
            var matchingFilters = __assign({}, nextProps.sortByOptions.filters);
            var keys = Object.keys(matchingFilters);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                if (!columns[key]) {
                    delete matchingFilters[key];
                }
            }
            var copy = nextProps.files.slice(0, nextProps.files.length);
            var filtered = copy;
            var sorted = filtered;
            if (nextProps.sortByOptions.sortBy &&
                nextProps.sortByOptions.sortBy !== '') {
                var filter = nextProps.metadata.list.find(function (x) { return x.id === nextProps.sortByOptions.sortBy; });
                if (filter) {
                    sorted = filtered.sort((0, sort_1.sortFoldersAndFiles)(filter)(nextProps.sortByOptions.order || 'asc'));
                }
            }
            nextProps.setFilteredAndSortedFiles(sorted.filter(function (x) { return x.type !== 'FOLDER'; }));
        }
    }
});
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('showRevisionList', 'setShowRevisionList', false), (0, recompose_1.withState)('selectedRevisions', 'setSelectedRevisions', []), (0, recompose_1.withState)('filteredAndSortedFiles', 'setFilteredAndSortedFiles', []), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), exports.lifecycles, recompose_1.pure);
var FilesPreviewViewPure = /** @class */ (function (_super) {
    __extends(FilesPreviewViewPure, _super);
    function FilesPreviewViewPure() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FilesPreviewViewPure.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var searchResultsToggled = (props.searchOptions.searchString &&
            props.searchOptions.searchString !== '') ||
            props.searchOptions.limitSearchToFolder.isSome() ||
            (props.searchOptions.containsTermString &&
                props.searchOptions.containsTermString !== '') ||
            props.searchOptions.searchFileType.isSome();
        var path = props.folderPath || [];
        return (React.createElement("div", { className: 'content-wrapper-content' },
            React.createElement("div", { className: 'files-preview-view' },
                React.createElement("div", { className: 'content' },
                    React.createElement(props.BreadCrumb, { filtering: props.filtering, navigateTo: props.navigateTo, path: path, currentProject: props.currentProject, currentBid: props.currentBid, currentBriefcase: props.currentBriefcase, searchResultsToggled: searchResultsToggled },
                        React.createElement("span", null, props.preview &&
                            props.preview.status === 'FETCHED' &&
                            props.preview.currentRevision
                            ? props.preview.currentRevision.name
                            : '')),
                    React.createElement("div", { className: 'viewer-container' },
                        React.createElement("div", { className: 'fullscreen-container', ref: function (div) { return (_this.fullscreenContainer = div); } },
                            React.createElement(Header_1.Header, { showRevisionButton: !props.currentBid, currentRevision: props.preview.status === 'FETCHED'
                                    ? props.preview.currentRevision
                                    : undefined, revisions: props.preview.revisions, files: props.filteredAndSortedFiles, container: this.fullscreenContainer, toggleFullscreen: function () {
                                    if (_this.fullscreenContainer) {
                                        (0, fullscreen_1.toggleFullscreen)(_this.fullscreenContainer);
                                    }
                                }, moveToFile: function (fileUUID, revisionUuid) {
                                    return props.moveToRevision(props.baseUrl, fileUUID, revisionUuid);
                                }, showRevisionList: props.showRevisionList, moveToFolder: function () {
                                    var splitted = props.baseUrl.split('/');
                                    props.navigateTo(splitted.slice(0, splitted.length - 4).join('/'), true);
                                }, setShowRevisionList: props.setShowRevisionList, 
                                // Manage models
                                currentProject: props.currentProject, folderTree: props.preview.folderTree, selectItem: props.selectItem, changeExpand: props.changeExpand, getContent: props.getContent, clearTree: props.clearTree, selectedRevisions: props.selectedRevisions, setSelectedRevisions: props.setSelectedRevisions }),
                            (function () {
                                if (props.preview.status === 'FETCHED' &&
                                    props.preview.currentRevision) {
                                    return (React.createElement(React.Fragment, null,
                                        React.createElement(Content, null,
                                            (function () {
                                                switch (props.preview.currentRevision.type) {
                                                    case 'IMAGE':
                                                        return (React.createElement(components_1.ImagePreview, { revision: props.preview.currentRevision }));
                                                    case 'VIDEO':
                                                        var testEl = document.createElement('video');
                                                        if (!props.preview.currentRevision.meta ||
                                                            !testEl.canPlayType(props.preview.currentRevision.meta
                                                                .content_type || '')) {
                                                            return (React.createElement(GenericErrorMessage_1.default, { icon: React.createElement(Icon_1.Icon, { className: "fa-exclamation-triangle" }), title: (0, translation_1.getLocalization)('filesPreview/preview/dwg/dearSokoProUser') }, (0, translation_1.getLocalization)('filesPreview/preview/error/previewIsNotSupported')));
                                                        }
                                                        return (React.createElement(components_1.VideoPreview, { revision: props.preview.currentRevision }));
                                                    case 'DWG':
                                                        return (React.createElement(components_1.DWGPreview, { convert: props.convert, revisions: props.selectedRevisions, revision: props.preview.currentRevision }));
                                                    case 'IFC':
                                                        return (React.createElement(components_1.IFCPreview, { convert: props.convert, revisions: props.selectedRevisions, revision: props.preview.currentRevision }));
                                                    case 'PDF':
                                                        return (React.createElement(components_1.PDFPreview, { revision: props.preview.currentRevision, token: props.token }));
                                                    case 'OTHER':
                                                    case 'SPREADSHEET':
                                                    case 'TEXT':
                                                    case 'PRESENTATION':
                                                        return (React.createElement(components_1.DocumentPreview, { revision: props.preview.currentRevision, token: props.token }));
                                                    default:
                                                        return (React.createElement(GenericErrorMessage_1.default, { icon: React.createElement(Icon_1.Icon, { className: "fa-exclamation-triangle" }), title: (0, translation_1.getLocalization)('filesPreview/preview/dwg/dearSokoProUser') }, (0, translation_1.getLocalization)('filesPreview/preview/error/previewIsNotSupported')));
                                                }
                                            })(),
                                            props.showRevisionList && (React.createElement(RevisionList, null, props.preview.revisions.map(function (file, index) { return (React.createElement("div", { className: "revision-row".concat(props.match.params.revisionUuid ===
                                                    file.uuid
                                                    ? ' selected'
                                                    : ''), onClick: function () {
                                                    return props.moveToRevision(props.baseUrl, props.match.params.fileUUID, file.uuid);
                                                } },
                                                React.createElement("strong", null,
                                                    (0, translation_1.getLocalization)('filesPreview/header/revisionList/revision'),
                                                    ' ',
                                                    file.version,
                                                    index === 0 &&
                                                        " (".concat((0, translation_1.getLocalization)('filesPreview/header/revisionList/current'), ")")),
                                                React.createElement("label", null, (0, translation_1.getLocalization)('filesPreview/header/revisionList/fileName')),
                                                React.createElement("div", null, file.name),
                                                React.createElement("label", null, (0, translation_1.getLocalization)('filesPreview/header/revisionList/createdAt')),
                                                React.createElement("div", null, getCreatedAt(file)),
                                                React.createElement("label", null, (0, translation_1.getLocalization)('filesPreview/header/revisionList/author')),
                                                React.createElement("div", null, getAuthor(file)))); }))))));
                                }
                                else if (props.preview.status === 'FETCHING') {
                                    return (React.createElement("div", { className: 'loader' },
                                        React.createElement(sok_ui_1.LoadingSpinner, null)));
                                }
                                else if (props.preview.status === 'FAILED' ||
                                    (props.preview.status === 'FETCHED' &&
                                        !props.preview.currentRevision)) {
                                    return (React.createElement("div", { className: 'content-wrapper-content' },
                                        React.createElement("div", { className: 'files-preview-view' },
                                            React.createElement("div", { className: 'content' },
                                                React.createElement("div", { className: 'viewer-container' },
                                                    React.createElement(GenericErrorMessage_1.default, { icon: React.createElement(Icon_1.Icon, { className: "fa-exclamation-triangle" }), title: (0, translation_1.getLocalization)('filesPreview/preview/dwg/dearSokoProUser') }, (0, translation_1.getLocalization)('filesPreview/error')))))));
                                }
                                else {
                                    return null;
                                }
                            })()),
                        props.preview.status === 'FETCHED' &&
                            props.preview.currentRevision &&
                            props.metadata.status === 'FETCHED' && (React.createElement(exports.Footer, { metaSchema: props.metadata.list, revision: props.preview.currentRevision })))))));
    };
    return FilesPreviewViewPure;
}(React.Component));
exports.FilesPreviewViewPure = FilesPreviewViewPure;
exports.default = enhance(FilesPreviewViewPure);
